module.exports = require("./se-NO.js");